var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("DefaultWidget", {
    staticClass: "view-cover",
    attrs: {
      disabled: !_vm.imageUrl,
      name: "查看封面",
      icon: "mdi-image-outline",
    },
    on: {
      click: function ($event) {
        return _vm.viewCover()
      },
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }